import swal from "sweetalert";
import axiosInstance from "../api";
import { setGetPartnerListData, setGetSinglePartner } from "../booking/bookingSlice";




export const addEmailNotification = (data, setLoading) => async (dispatch) => {
    setLoading(true);
    try {
        const response = await axiosInstance.post("admin/customers/push-notification", data);
        if (response?.data?.status) {
            swal({
                text: response?.data?.response?.message,
                icon: "success",
                button: "Close",
                timer: 1500,
            });
            window.location.reload()
            // return response;
        }
        else {
            swal({
                text: response?.data?.message,
                icon: "error",
                button: "Close",
                timer: 1500,
            });
        }

    } catch (err) {
        // console.error(err);
    } finally {
        setLoading(false);
    }
};




